import { Event, EventType, EventAudience } from './types';

// Define EventType and EventAudience as string literals for the mock data values
const EventTypeValues = {
  CONFERENCE: 'conference' as EventType,
  WORKSHOP: 'workshop' as EventType,
  COURSE: 'course' as EventType,
  SYMPOSIUM: 'symposium' as EventType,
};

const EventAudienceValues = {
  STUDENTS: 'medical_students' as EventAudience,
  PROFESSIONALS: 'healthcare_professionals' as EventAudience,
  PUBLIC: 'general_public' as EventAudience,
};

// Helper function to map string audience to EventAudience type
const mapToAudience = (audience: string): EventAudience => {
  switch (audience) {
    case "STUDENTS":
      return EventAudienceValues.STUDENTS;
    case "PROFESSIONALS":
      return EventAudienceValues.PROFESSIONALS;
    case "PUBLIC":
      return EventAudienceValues.PUBLIC;
    default:
      return EventAudienceValues.PUBLIC;
  }
};

export const futureEvents: Event[] = [
];

// Export all events as default export
const allEvents = [...futureEvents];
export default allEvents;
